import React from 'react';
import PropTypes from 'prop-types';
import { createEspirometria, getHistoricoEspirometria } from '../../../domain/api/MedicionesApi';
import {
	calcularPorcentajeEspirometria,
	validarEspirometria,
} from '../../utils/HelpValidacionMediciones';
import {
	COLUMNAS_HISTORIAL_ESPIROMETRIA,
	NOTA_RANGOS_ESPIROMETRIA,
	RANGOS_SUGERIDOS_ESPIROMETRIA,
} from '../../utils/HelpMediciones';
import usePanelMedicion from './usePanelMedicion';
import useHistorialMedicion from './useHistorialMedicion';
import HistorialMediciones from './HistorialMediciones';
import PanelMedicion from './PanelMedicion';
import CampoMedicion from './CampoMedicion';
import RangosSugeridos from './RangosSugeridos';

const VALORES_INICIALES = { pef: '', pred: '' };

/** Panel de registro de espirometría: PEF y PRED editables, porcentaje calculado. */
const PanelEspirometria = ({ modulo, numeroDocumento, evbi, onRegistrado }) => {
	const historial = useHistorialMedicion({ cargar: getHistoricoEspirometria, numeroDocumento });
	const panel = usePanelMedicion({
		valoresIniciales: VALORES_INICIALES,
		validar: validarEspirometria,
		enviar: createEspirometria,
		numeroDocumento,
		evbi,
		onExito: () => {
			// Solo con codigoRespuesta '0000': usePanelMedicion no llama onExito en error
			historial.recargar();
			if (onRegistrado) {
				onRegistrado(modulo.id);
			}
		},
	});
	// Derivado en render: se recalcula con cada tecla, sin estado propio
	const porcentaje = calcularPorcentajeEspirometria(panel.valores.pef, panel.valores.pred);

	return (
		<PanelMedicion
			modulo={modulo}
			guardando={panel.guardando}
			bloqueado={panel.bloqueado}
			resultado={panel.resultado}
			onGuardar={panel.guardar}
			onLimpiar={panel.limpiar}
			pie={
				<HistorialMediciones
					id="espirometria"
					columnas={COLUMNAS_HISTORIAL_ESPIROMETRIA}
					historial={historial}
				/>
			}
		>
			<RangosSugeridos id="espirometria" rangos={RANGOS_SUGERIDOS_ESPIROMETRIA} nota={NOTA_RANGOS_ESPIROMETRIA} />
			<CampoMedicion
				id="medicion-pef"
				label="PEF"
				unidad="L/min"
				value={panel.valores.pef}
				onChange={(texto) => panel.setValor('pef', texto)}
				error={panel.errores.pef}
			/>
			<CampoMedicion
				id="medicion-pred"
				label="PRED"
				unidad="L/min"
				value={panel.valores.pred}
				onChange={(texto) => panel.setValor('pred', texto)}
				error={panel.errores.pred}
			/>
			<CampoMedicion
				id="medicion-porcentaje"
				label="Porcentaje"
				unidad="%"
				value={porcentaje == null ? '--' : String(porcentaje)}
				readOnly
				error={panel.errores.porcentaje}
			/>
		</PanelMedicion>
	);
};

PanelEspirometria.propTypes = {
	modulo: PropTypes.shape({
		id: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		descripcion: PropTypes.string,
	}).isRequired,
	numeroDocumento: PropTypes.string,
	evbi: PropTypes.number,
	onRegistrado: PropTypes.func,
};

export default PanelEspirometria;
